import React, { useEffect, useState } from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery, Box } from "@mui/material";
import { useTheme } from "../style/theme";
import StorePng from "../assets/Icons/store.png";
import AppsIcon from "@mui/icons-material/Apps";
import { TfiLayoutColumn3 } from "react-icons/tfi";
import { GoCreditCard } from "react-icons/go";
import { BsCollectionPlay } from "react-icons/bs";

const BottomNavBar = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");
  const { mode } = useTheme();

  // Define routes that should display the BottomNavBar
  const showBottomNav = [
    "/myStore",
    "/subscription",
    "/subscription/hr/purchase",
    "/subscription/files/purchase",
    "/subscription/E-Sign/purchase",
    "/subscription/Projects/purchase",
    "/payments",
    "/activity",
    "/address",
  ].includes(location.pathname);

  // Update state when route changes
  useEffect(() => {
    switch (location.pathname) {
      case "/subscription/hr/purchase":
        setValue(0);
        break;
      case "/subscription":
        setValue(1);
        break;
      case "/activity":
        setValue(3);
        break;
      case "/payments":
        setValue(4); // ✅ Correct value for Payments tab
        break;
      default:
        setValue(0);
        break;
    }
  }, [location.pathname]);

  // Navigation handler
  const handleNavigation = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate("/myStore");
        break;
      case 1:
        navigate("/subscription");
        break;
      case 2:
        window.location.href = "https://clikkle.com/products";
        break;
      case 3:
        navigate("/activity");
        break;
      case 4:
        navigate("/payments"); // ✅ Corrected: now index 4 goes to /payments
        break;
      default:
        break;
    }
  };

  if (!isMobile || !showBottomNav) {
    return null;
  }

  return (
    <Box>
      <BottomNavigation
        value={value}
        onChange={handleNavigation}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          boxShadow: 3,
          zIndex: 1000,
          backgroundColor: mode === "light" ? "white" : "#141414",
          display: "flex",
          justifyContent: "space-between",
          px: 0,
        }}
      >
        {[
          {
            label: "Store",
            icon: (
              <img
                src={StorePng}
                alt="Store"
                style={{ width: 24, height: 24 }}
              />
            ),
          },
          { label: "Services", icon: <BsCollectionPlay size={24} /> },
          { label: "", icon: <AppsIcon /> },
          { label: "Activities", icon: <TfiLayoutColumn3 size={24} /> },
          { label: "Payments", icon: <GoCreditCard size={24} /> },
        ].map((item, index) => (
          <BottomNavigationAction
            key={index}
            label={item.label}
            icon={
              <Box
                sx={{
                  px: 0.5,
                  borderRadius: "0.75rem",
                  backgroundColor:
                    value === index ? "#3767B133" : "transparent",
                }}
              >
                {item.icon}
              </Box>
            }
            sx={{
              minWidth: 50,
              paddingX: 0.5,
              "& .MuiBottomNavigationAction-label": {
                fontSize: "0.65rem",
              },
              color: mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#A5A5A5",
            }}
            showLabel
          />
        ))}
      </BottomNavigation>
    </Box>
  );
};

export default BottomNavBar;
